import api from './api';
import types from './mutation-types';
import moment from 'moment';

function getRowKey() {
	return moment.now().toString();
}

export default {
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setStateClear_({ commit }) {
		commit(types.STATE_CLEAR);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.GROUPS, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	getOpCdMng_({ commit, state }) {
		const { searchParams, groups } = state;
		return api
			.getOpCdMng({ searchParams: searchParams, currentPage: groups.currentPage, pageUnit: groups.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'gridList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: data.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	//  팝업 그리드에서 추가버튼 클릭시
	addAsPartListRow_({ state, commit }) {
		const rowKey = getRowKey();
		const addedRow = {
			rowType: 'add',
			partNo: '', //품번
			partNm: '', //품명
			opCd: '', //op코드
			strtDd: '', //시작일
			asCst: '', //as부품가
			lts: '', //LTS
			pwaYn: '', //pwa 여부
			usePrd: '', //보증기간
			milg: '' //보증사용거리
		};
		const value = [...state.gridList, addedRow];
		commit(types.DEFAULT_ASSIGN, { key: 'gridList', value });
		return addedRow;
	},
	// 저장
	saveOpCdMng_({ commit }, saveParams) {
		return api
			.postOpCdMng({ saveParams })
			.then(data => {
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async excelTempDown_(store, params) {
		try {
			const response = await api.excelTempDown(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw new Error(error?.header);
		}
	}
};
